import type { SetPointPosition } from "./types";

export const setPointPosition: SetPointPosition = ({
  points,
  index,
  position,
}) =>
  points.map((point, pointIndex) => (pointIndex === index ? position : point));
